import store from "@/store";
import { merchantNotificationRepository } from "@/forms/api/repository-factory";
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import FIELD_NAMES from "@/forms/constants/field-names";
import callApi from "@/lib/helpers/call-api";

const getPayload = () => {
  const { values } = store.state.formData;

  const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
  const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
  const phoneNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
  const email = getValueByFieldName(values, FIELD_NAMES.email);
  const company = getValueByFieldName(values, FIELD_NAMES.companyName);
  const emirate = getValueByFieldName(values, FIELD_NAMES.emirates); //getValueByFieldName(values, FIELD_NAMES.nationality);

  return {
    "first-name": firstName,
    "last-name": lastName,
    "company-name": company,
    "email-id": email,
    "mobile-no": phoneNumber,
    emirates: emirate
  };
};

export default {
  async merchantNotification(currentStep, callbacks) {
    const { form } = currentStep;
    let response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: merchantNotificationRepository.merchantNotification,
      payload: getPayload()
    });
    if (response) {
    }
  }
};
